'use strict';

/**
 * Top Load
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

import 'js-cookie';

const Cookies = require('js-cookie');

// ----------------------------------------
// Public
// ----------------------------------------

(function ($) {
	$(window).on('load', function () {
		//  отключение всплывающей формы Бинотела
		if ($('#disabled-binotel').length) {
			let bgc = window.BinotelGetCall;

			if (typeof bgc !== 'undefined') {
				bgc[Object.keys(bgc)[0]].activeFormStatus = 0;
			}
		}

		// Удаление стандартного CSS от бинотела
		(function () {
			let count = 10;
			let interval = setInterval(function () {
				count--;
				let style = document.head.querySelector('link[rel="stylesheet"][href*="getcall/css/theme"]');
				if (style) {
					style.remove();
					document.documentElement.classList.add('custom-binotel');
					clearInterval(interval);
				}
				if (count <= 0) {
					clearInterval(interval);
					console.info('Используется стандартный стиль от Binotel');
				}
			}, 500);
		})();

         /* setTimeout(function () {
            if (window.location.hash === '#day') {
                document.getElementById('bingc-active-content').innerHTML = `
				<div class="bingc-we-will-call-you">Хотите, перезвоним Вам<br>в течение 10 минут?</div>
				<div class="bingc-active-get-phone-form">
					<form id="bingc-active-get-phone-form" class="bingc-active-get-phone-form">
						<div class="bingc-active-get-phone-form-input-border"></div>
						<input type="tel" id="bingc-active-get-phone-form-input" class="bingc-active-get-phone-form-input" placeholder="Ваш номер телефона" value="" autocomplete="off" onfocus="this.value = this.value;">
							<a href="javascript:void(0);" class="bingc-active-phone-form-button">Перезвоните</a>
							<span class="bingc-sample-countdown-timer"><span>00:</span>29<span>:99</span></span>
					</form>
				</div>
				<div id="bingc-phone-sample" class="bingc-phone-sample"><span>Например: 067 000 00 00</span></div>
				<div class="bingc-statistics">Свободных операторов на линии: 3 Заказов звонков сегодня: 20+</div>`;
            } else {
                document.getElementById('bingc-active-content').innerHTML = `
				<div class="bingc-active-content" id="bingc-active-content">
					<div class="bingc-we-will-call-you bingc-offline-form">Хотите, перезвоним Вам<br>
						<div id="bingc-active-date-selection-select-day" class="bingc-active-date-selection-select-day bingc-active-date-selection-select-day-hover">
							<svg class="bingc-active-date-selection-arrows" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 10 14" enable-background="new 0 0 10 14" xml:space="preserve"><path fill-rule="evenodd" clip-rule="evenodd" d="M0,4.995L4.995,0L9.99,4.995"></path></svg>
							<span id="bingc-active-date-selection-selected-day" class="bingc-active-date-selection-selected-day">завтра</span><input type="hidden" id="bingc-active-date-selection-selected-day-index" value="0">
							<div id="bingc-active-date-selection-select-day-list-of-days-container" class="bingc-active-date-selection-select-day-list-of-days-container">
								<ul id="bingc-active-date-selection-select-day-list-of-days" class="bingc-active-date-selection-select-day-list-of-days">
									<li value="0">завтра</li>
									<li value="1">в понедельник</li>
									<li value="2">во вторник</li>
								</ul>
							</div>
						</div>
						точно в:
					</div>
					<div class="bingc-active-get-phone-form bingc-offline-form">
						<form id="bingc-active-get-phone-form" class="bingc-active-get-phone-form">
							<div class="bingc-active-get-phone-form-date-selection">
								<div id="bingc-active-date-selection-select-hour" class="bingc-active-date-selection-select-hour bingc-active-date-selection-select-hour-hover">
									<span id="bingc-active-date-selection-selected-hour" class="bingc-active-date-selection-selected-hour">10</span>
									<svg class="bingc-active-date-selection-arrows" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 10 14" enable-background="new 0 0 10 14" xml:space="preserve"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.99,8.905L4.995,13.9L0,8.905"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M0,4.995L4.995,0L9.99,4.995"></path></svg>
									<div id="bingc-active-date-selection-select-hour-list-of-hours-container" class="bingc-active-date-selection-select-hour-list-of-hours-container two-columns"><ul class="bingc-active-date-selection-select-hour-list-of-hours "><li>09</li><li>10</li><li>11</li><li>12</li><li>13</li><li>14</li><li>15</li><li>16</li><li>17</li></ul><ul class="bingc-active-date-selection-select-hour-list-of-hours second-column"><li>18</li></ul></div>
								</div>
								<div id="bingc-active-date-selection-select-minutes" class="bingc-active-date-selection-select-minutes bingc-active-date-selection-select-minutes-hover">
									<span id="bingc-active-date-selection-selected-minutes" class="bingc-active-date-selection-selected-minutes">00</span>
									<svg class="bingc-active-date-selection-arrows" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 10 14" enable-background="new 0 0 10 14" xml:space="preserve"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.99,8.905L4.995,13.9L0,8.905"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M0,4.995L4.995,0L9.99,4.995"></path></svg>
									<div id="bingc-active-date-selection-select-minutes-list-of-minutes-container" class="bingc-active-date-selection-select-minutes-list-of-minutes-container">
										<ul class="bingc-active-date-selection-select-minutes-list-of-minutes">
											<li>00</li>
											<li>15</li>
											<li>30</li>
											<li>45</li>
										</ul>
									</div>
								</div>
							</div>
							<div class="bingc-active-get-phone-form-input-border bingc-offline-form"></div>
							<input type="tel" id="bingc-active-get-phone-form-input" class="bingc-active-get-phone-form-input" placeholder="Ваш номер телефона" value="" autocomplete="off" onfocus="this.value = this.value;"><a href="javascript:void(0);" id="bingc-active-phone-form-button" class="bingc-active-phone-form-button">Жду
							звонка</a></form>
				</div>
				<div id="bingc-phone-sample" class="bingc-phone-sample"><span>Например: 067 000 00 00</span></div>`;
            }

            setTimeout(function () {
                document.querySelector('.bingc-active-closed').classList.remove('bingc-active-closed');
            }, 500);

            console.clear();
        }, 2500); */

		if (window.counters !== undefined) {
			for (var i = 0; i < window.counters.length; i++) {
				window.counters[i]();
			}
		}
		window.onRoistatAllModulesLoaded = function () {
			setTimeout(function () {
				$('.js-promo-code').text(window.roistat.visit).addClass('promocode__number--is-load');
			}, 1000);
		};

		(function () {
			let $el = $('.js-lozad-force');
			if ($el.length) {
				$el.get().forEach(item => {
					window.lazyLoad.triggerLoad(item);
				});
			}
		}());

		/* (function () {
			let $el = $('[data-auto-type="advice"]');

			function getC () {
				if (typeof Cookies.getJSON('advice') !== 'undefined') {
					return Cookies.getJSON('advice');
				} else {
					return {state: false};
				}
			}

			function setC (obj) {
				Cookies.set('advice', obj, {expires: 365});
			}

			if (getC().state !== 'is-shown' && !Cookies.get('w-form')) {
				$(document).on('mouseleave.advice', function (e) {
					if (e.clientY <= 0) {
						if (!Cookies.get('w-form') && !$.magnificPopup.instance.isOpen) {
							$el.trigger('click');
							setC({state: 'is-shown'});
							$(document).off('.advice');
						}
					}
				});
			}
		}()); */

		(function () {
			let $el = $('.js-sales-funnel');
			if (!$el.length) return false;

			function getC () {
				if (typeof Cookies.getJSON('sales-funnel') !== 'undefined') {
					return Cookies.getJSON('sales-funnel');
				} else {
					return {state: false};
				}
			}

			function setC (obj) {
				Cookies.set('sales-funnel', obj, {expires: 7});
			}

			if (getC().state !== 'is-shown' && !Cookies.get('w-form')) {
				// Добавил интервал, т.к. не красиво, когда я только открыл вкладку и буквально сразу тянусь вверх (может, чтобы просто переместить вкладку), а оно мне всплывайку показывает
				setTimeout(function () {
					$(document).on('mouseleave.sales-funnel', function (e) {
						if (e.clientY <= 0) {
							if (!Cookies.get('w-form') && !$.magnificPopup.instance.isOpen) {
								$el.trigger('click');
								setC({state: 'is-shown'});
								$(document).off('.sales-funnel');

								const gtagString = 'gtag("event", "show-exit", {"event_category": "popup-funnel", "event_label": "", "value": ""})';
								if (window.gtag !== undefined) {
									window.gtag('event', 'show-exit', {
										'event_category': 'popup-funnel',
										'event_label': '',
										'value': ''
									});
									console.info('Выполнена строка = ' + gtagString);
								} else {
									console.error('Объект ga не определен! Строка НЕ выполнена = ' + gtagString);
								}
							}
						}
					});
				}, 10000);
			}
		}());

		(function () {
			let url = window.location.search;
			let $el = $('[data-auto-type="rating"]');
			let timeShow = +$el.data('time');

			function getC () {
				if (typeof Cookies.getJSON('rating') !== 'undefined') {
					return Cookies.getJSON('rating');
				} else {
					return {state: false, time: false};
				}
			}

			function setC (obj) {
				Cookies.set('rating', obj, {expires: 365});
			}

			function showPopUp (time) {
				if (!$.magnificPopup.instance.isOpen) {
					setTimeout(function () {
						$el.trigger('click');
						setC({state: 'is-shown'});
					}, time * 1000);
				}
			}

			if (getC().state !== 'is-shown') {
				if (url.indexOf('ratingruneta.ru') !== -1 && $el.length) {
					setC({state: 'is-active', time: timeShow});
					showPopUp(timeShow);
				}

				if (getC().state === 'is-active') {
					showPopUp(getC().time);
				}
			}
		}());

		(function () {
			let hash = window.location.hash;
			let $el = $('.js-auto-play');
			if (hash === '#auto-play' && $el.length) {
				setTimeout(function () {
					$el.trigger('click');
				}, 50);
			}
		}());

		(function () {
			let $el = $('.js-auto-click');
			if (!$el.length) return false;
			setTimeout(function () {
				$el.trigger('click');
			}, 100);
		}());

		(function () {
			let hash = window.location.hash;
			let $el = $('.js-working-day');
			if (hash === '#working-day' && $el.length) {
				setTimeout(function () {
					$el.trigger('click');
				}, 50);
			}
		}());

		(function () {
			let hash = window.location.hash;
			let $el = $('.js-day-off');
			if (hash === '#day-off' && $el.length) {
				setTimeout(function () {
					$el.trigger('click');
				}, 50);
			}
		}());

		(function () {
			let hash = window.location.hash;
			let $el = $('.js-preparing-offer');
			if (hash === '#preparing-offer' && $el.length) {
				setTimeout(function () {
					$el.trigger('click');
				}, 50);
			}
		}());

		(function () {
			let hash = window.location.hash;
			let $el = $('.js-commercial-offer');
			if (hash === '#commercial-offer' && $el.length) {
				setTimeout(function () {
					$el.trigger('click');
				}, 50);
			}
		}());

		(function () {
			let freeAccess = $('.js-free-access');
			let salesFunnel = $('.js-sales-funnel');
			if (!freeAccess.length || !salesFunnel.length) return false;

			let hasClick = false;
			const gtagString = 'gtag("event", "show-click", {"event_category": "popup-funnel", "event_label": "", "value": ""})';

			freeAccess.on('click', function () {
				salesFunnel.trigger('click');

				if (!hasClick) {
					hasClick = true;
					if (window.gtag !== undefined) {
						window.gtag('event', 'show-click', {
							'event_category': 'popup-funnel',
							'event_label': '',
							'value': ''
						});
						console.info('Выполнена строка = ' + gtagString);
					} else {
						console.error('Объект ga не определен! Строка НЕ выполнена = ' + gtagString);
					}
				}
			});
		}());

		/* (function () {
			const POPUP_SALES_INTERVAL = 86400000; // частота показа всплывайки, в миллисекундах, 86400000 = 24 часа
			const POPUP_SALES_DELAY = 1000 * 20; // через какое время, после загрузки страницы, отобразить всплывайку

			setTimeout(function () {
				let $salesFunnel = $('.js-sales-funnel');
				if (!$salesFunnel.length) return false;

				let popupSalesFunnelLastShow = parseFloat(window.localStorage.getItem('popupSalesFunnelLastShow')) || 1;
				let dateNow = Date.now();

				if ((popupSalesFunnelLastShow + POPUP_SALES_INTERVAL) > dateNow) return false; // рано по времени еще раз показывать
				if ($.magnificPopup.instance.isOpen) return false; // сейчас открыта другая всплывайка

				$salesFunnel.trigger('click');
				window.localStorage.setItem('popupSalesFunnelLastShow', dateNow);
			}, POPUP_SALES_DELAY);
		}()); */
	});
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/_modules/load.js